import { channel } from 'redux-saga';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';

import { getLatestDevicesPing, watchDeviceLive } from '../../shared/db/report-db';
import { iFullStoreState } from '../../shared/interfaces';
import {
    FETCH_DEVICES_LATEST_PING,
    SET_ALL_DEVICES_INFO,
    SET_DEVICE_INFO,
    setAllDevicesInfo, setDeviceInfo,
    setDevicesLatestPing,
    updateDeviceLocation
} from '../reducers/devicesData/AC';

const watchDevicesLocationsChannel = channel();

function* worker (action: ReturnType<typeof setAllDevicesInfo> | ReturnType<typeof setDeviceInfo>) {
    const devicesIdsFromStore: Array<string> = yield select(
        (state: iFullStoreState) => state.devicesData.devicesLastPing.keySeq().toArray(),
    );

    switch (action.type) {
    case SET_DEVICE_INFO: {

        const {deviceDetails} = (action as ReturnType<typeof setDeviceInfo>).payload;

        if (!devicesIdsFromStore.includes(deviceDetails.id)) {
            watchDeviceLive(deviceDetails.id, (ping) => watchDevicesLocationsChannel.put(updateDeviceLocation(deviceDetails.id, ping)));
        }

        break;
    }
    case SET_ALL_DEVICES_INFO: {
        const { devicesDetails } = (action as ReturnType<typeof setAllDevicesInfo>).payload;
        // This is old version //
        for (const deviceId of Object.keys(devicesDetails)) {
            if (!devicesIdsFromStore.includes(deviceId)) {
                watchDeviceLive(deviceId, (ping) => watchDevicesLocationsChannel.put(updateDeviceLocation(deviceId, ping)));
                // TODO: next function before refactoring never calls. Maybe can it remove.
                // populateDeviceEarliestPing(user)(deviceId);
            }
        }

        // const object: Record<string, iDevicePing | null> = {};
        // const promises = Object.keys(devicesDetails)
        //     .filter((deviceId) => !devicesIdsFromStore.includes(deviceId))
        //     .map((deviceId) => {
        //         return new Promise<void>((resolve) => {
        //             watchDeviceLive(deviceId, (ping) => {
        //                 object[deviceId] = ping;
        //                 resolve();
        //             });
        //         });
        //     });

        // Promise.all(promises).then(() => {
        //     // @ts-ignore
        //     watchDevicesLocationsChannel.put(updateDeviceLocations(new Map(object)));
        // });
        break;
    }
    }
}

function* fetchDevicesLatestPingWorker() {
    try {
        const devicesIdsFromStore: Array<string> = yield select(
            (state: iFullStoreState) => state.devicesData.devicesDetails.keySeq().toArray(),
        );

        const latestPings = yield call(getLatestDevicesPing, devicesIdsFromStore);

        yield put(setDevicesLatestPing(latestPings));
    } catch (error) {
        console.error('Error fetching latest device pings:', error);
    }
}

export default function* () {
    yield takeEvery(FETCH_DEVICES_LATEST_PING, fetchDevicesLatestPingWorker);
    yield takeEvery([SET_ALL_DEVICES_INFO, SET_DEVICE_INFO], worker);

    while (true) {
        const action = yield take(watchDevicesLocationsChannel);

        yield put(action);
    }
}
